import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FlexColumn } from 'ui-components/components/flex';

import Global from '../../../store/global-selectors';
import { SimpleModal } from '../../../components/simple-modal/simple-modal';
import { AddressFields } from '../../../address/address-fields';
import { useYupFormValidation } from '../../../validation/use-yup-form-validation';
import { addressSchema } from '../../../address/address-fields/address-schema';
import { COMPANY, PHONE } from '../../../address/constants';
import { commonRequiredValidationErrors } from '../../../address/address-fields/messages';
import messages from './messages';

const validationSchema = addressSchema.shape({
  [COMPANY]: addressSchema.fields[COMPANY]
    .required(() => <FormattedMessage {...commonRequiredValidationErrors[COMPANY]} />)
    .min(2, () => <FormattedMessage {...messages.companyMinLengthError} />),
});
const fieldsConfig = {
  additionalRequiredFields: [PHONE, COMPANY],
};

export const AddIORModal = ({ onClose, onAddIOR }) => {
  const homeCountry = useSelector(Global.selectSellerHomeCountry);
  const [address, setAddress] = useState({
    countryCode: homeCountry,
  });
  const [showAllErrors, setShowAllErrors] = useState(false);

  const { errors: validationErrors, isValid } = useYupFormValidation({
    form: address,
    schema: validationSchema,
  });
  const handleAddressChange = useCallback((property, value) => {
    setAddress((prevAddress) => ({ ...prevAddress, [property]: value }));
  }, []);

  const handleOnAction = useCallback(() => {
    if (!isValid) {
      setShowAllErrors(true);
      return;
    }
    onAddIOR(address);
  }, [isValid, address, onAddIOR]);

  return (
    <SimpleModal
      actionMessage={messages.addIOR}
      cancelMessage={messages.cancelAddIOR}
      headerMessage={messages.addIORModalTitle}
      onAction={handleOnAction}
      onCancel={onClose}
      onClose={onClose}
      size='small'
    >
      <FlexColumn>
        <AddressFields
          additionalRequiredFields={fieldsConfig.additionalRequiredFields}
          address={address}
          errors={validationErrors}
          hiddenFields={fieldsConfig.hiddenFields}
          onChange={handleAddressChange}
          showAllErrors={showAllErrors}
        />
      </FlexColumn>
    </SimpleModal>
  );
};
